module.exports = __webpack_public_path__ + "static/media/RecirculadorasAHW.ea3d8e90.jpg";